import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=1597faa1&scoped=true&"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&id=1597faa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597faa1",
  null
  
)

export default component.exports